import React, { useContext, useEffect, useState } from "react";
import Footer from "../components/Footer";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../context/auth";
import { SearchContext } from "../context/HotelRoomSearch";
import dayjs from "dayjs";
import { message } from "antd";

export default function SingleRoomPage() {
  // Variables
  window.scrollTo(0, 0);
  const { roomId } = useParams();
  const { token, authorizeUserData } = useContext(AuthContext);
  const { searchValues } = useContext(SearchContext);
  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();

  // State Handling
  const [roomsData, setRoomsData] = useState();
  const [bookingsData, setBookingsData] = useState();
  const [loading, setLoading] = useState(true);

  //   Get Room's Data
  const singleRoom = async () => {
    try {
      const response = await fetch(
        `https://hotelbnb-backend.onrender.com/room/${roomId}`
      );
      const result = await response.json();

      if (response.ok) {
        setRoomsData(result);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    singleRoom();
  }, []);

  useEffect(() => {
    // Getting the checkout and checkin dates difference
    const checkout_date = dayjs(searchValues?.checkout);
    const date_diff = checkout_date.diff(searchValues?.checkin, "day");

    // Setting the total bill of this booking
    const booking_total_price = date_diff * roomsData?.room_per_day_price;

    // Setting the bookings details in bookingsData State Variable
    setBookingsData({
      room_img: roomsData?.room_imgOne,
      booking_holder_name: `${authorizeUserData?.user_first_name} ${authorizeUserData?.user_last_name}`,
      booking_holder_email: authorizeUserData?.user_email,
      booking_from: searchValues?.checkin,
      booking_to: searchValues?.checkout,
      booking_hotel: roomsData?.room_hotel_name,
      booking_room_number: roomsData?.room_number,
      booking_room_price: roomsData?.room_per_day_price,
      booking_total: booking_total_price.toString(),
      booking_status: "Pending",
    });
  }, [roomsData, searchValues]);

  // Setting the Booking Added Message
  const bookingAddedAlert = () => {
    messageApi.open({
      type: "success",
      content: "Booking added please pay to confirm it",
      duration: 2,
    });
  };

  // Setting the Booking Not Added Message
  const bookingNotAddedAlert = () => {
    messageApi.open({
      type: "error",
      content: "Booking Error",
      duration: 2,
    });
  };

  const createBooking = async () => {
    window.scrollTo(0, 0);
    const response = await fetch(
      "https://hotelbnb-backend.onrender.com/add-pending-bookings-toDb",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(bookingsData),
      }
    );

    // Checking Response
    if (response.ok) {
      const result = await response.json();
      bookingAddedAlert();
      setTimeout(() => {
        navigate("/my-bookings");
      }, 2500);
    } else if (!response.ok) {
      bookingNotAddedAlert();
    }
  };

  // Bookings Process
  const doingBooking = () => {
    if (token) {
      createBooking();
    } else {
      navigate("/login");
    }
  };

  if (loading)
    return (
      <div className="d-flex flex-column gap-2 justify-content-center align-items-center loading-state">
        <div className="spinner-grow" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );

  if (!loading)
    return (
      <>
        {contextHolder}
        {/* Hero Section Start */}
        <div className="container-fluid p-0 singleHotelRoom-hero-section hero-section-spacing">
          <div className="row app-container gap-3 justify-content-between align-items-center">
            {/* Room Images Slider Start */}
            <div className="col-lg-6 col-12 room-images-slider-cover p-0">
              <div id="hotelRoomImagesSlider" className="carousel slide">
                <div className="carousel-inner">
                  <div className="carousel-item active">
                    <img
                      src={roomsData.room_imgOne}
                      className="d-block w-100"
                      alt="Room Image"
                    />
                  </div>
                  <div className="carousel-item">
                    <img
                      src={roomsData.room_imgTwo}
                      className="d-block w-100"
                      alt="Room Image"
                    />
                  </div>
                  <div className="carousel-item">
                    <img
                      src={roomsData.room_imgThree}
                      className="d-block w-100"
                      alt="Room Image"
                    />
                  </div>
                </div>
                <button
                  className="carousel-control-prev"
                  type="button"
                  data-bs-target="#hotelRoomImagesSlider"
                  data-bs-slide="prev"
                >
                  <span
                    className="carousel-control-prev-icon"
                    aria-hidden="true"
                  ></span>
                  <span className="visually-hidden">Previous</span>
                </button>
                <button
                  className="carousel-control-next"
                  type="button"
                  data-bs-target="#hotelRoomImagesSlider"
                  data-bs-slide="next"
                >
                  <span
                    className="carousel-control-next-icon"
                    aria-hidden="true"
                  ></span>
                  <span className="visually-hidden">Next</span>
                </button>
              </div>
            </div>
            {/* Room Images Slider End */}

            {/* Room Details And Amenities Start */}
            <div className="col-lg-5 col-12 room-details-cover px-lg-2 px-0 mt-lg-0 mt-3">
              {/* Room Name */}
              <h4 className="fw-semibold mb-4 text-capitalize">
                {roomsData.room_name}
              </h4>

              {/* Room Details Start */}
              <div className="room-details">
                <p className="d-flex align-items-center">
                  <img
                    src="/images/icons/roomNumber.png"
                    alt="room-number"
                    className="me-1"
                    style={{ width: "16px" }}
                  />
                  <span className="text-capitalize">
                    Room {roomsData.room_number}
                  </span>
                </p>
                <p>
                  <i className="fa-solid fa-user-group me-1"></i>
                  <span>{roomsData.room_max_people} People</span>
                </p>
                <p>
                  <i className="fa-solid fa-bed me-1"></i>
                  <span>{roomsData.room_beds} Beds</span>
                </p>
                <p>
                  <i className="fa-solid fa-chart-area me-1"></i>
                  <span>{roomsData.room_area} sq ft</span>
                </p>
              </div>
              {/* Room Details Start */}

              {/* Room Amenities Start */}
              <div className="room-amenities">
                {/* Heading */}
                <h6 className="pt-1 mb-3">Room amenities</h6>

                {/* Amenities Start */}
                <div className="col-12 p-0 d-flex flex-sm-nowrap flex-wrap justify-content-between gap-sm-2 gap-0">
                  {/* Side One Start */}
                  <div className="col-6 side-one room-page-amenities-side">
                    <p className="mb-2">
                      <i className="fa-solid fa-check me-2"></i>
                      <span className="text-capitalize">
                        {roomsData.room_amenities[0].ra_one}
                      </span>
                    </p>
                    <p className="mb-2">
                      <i className="fa-solid fa-check me-2"></i>
                      <span className="text-capitalize">
                        {roomsData.room_amenities[0].ra_two}
                      </span>
                    </p>
                    <p className="mb-2">
                      <i className="fa-solid fa-check me-2"></i>
                      <span className="text-capitalize">
                        {roomsData.room_amenities[0].ra_three}
                      </span>
                    </p>
                    <p className="mb-2">
                      <i className="fa-solid fa-check me-2"></i>
                      <span className="text-capitalize">
                        {roomsData.room_amenities[0].ra_four}
                      </span>
                    </p>
                  </div>
                  {/* Side One End */}

                  {/* Side Two Start */}
                  <div className="col-6 side-two room-page-amenities-side">
                    <p className="mb-2">
                      <i className="fa-solid fa-check me-2"></i>
                      <span className="text-capitalize">
                        {roomsData.room_amenities[0].ra_five}
                      </span>
                    </p>
                    <p className="mb-2">
                      <i className="fa-solid fa-check me-2"></i>
                      <span className="text-capitalize">
                        {roomsData.room_amenities[0].ra_six}
                      </span>
                    </p>
                    <p className="mb-2">
                      <i className="fa-solid fa-check me-2"></i>
                      <span className="text-capitalize">
                        {roomsData.room_amenities[0].ra_seven}
                      </span>
                    </p>
                    <p className="mb-2">
                      <i className="fa-solid fa-check me-2"></i>
                      <span className="text-capitalize">
                        {roomsData.room_amenities[0].ra_eight}
                      </span>
                    </p>
                  </div>
                  {/* Side Two End */}
                </div>
                {/* Amenities End */}
              </div>
              {/* Room Amenities End */}
            </div>
            {/* Room Details And Amenities End */}
          </div>
        </div>
        {/* Hero Section End */}

        {/* Room Description, Price and Book Now Button Start */}
        <div className="container-fluid p-0 room-description">
          <div className="row app-container">
            <div className="col-md-9 col-12 p-0 pe-3">
              <h3 className="mb-3 room-desc-heading">Room Description</h3>
              <p className="room-desc-text text-capitalize">
                {roomsData.room_description}
              </p>
              <p className="room-desc-price">
                <span className="price">${roomsData.room_per_day_price} </span>
                <span className="perDay">/day</span>
              </p>
              <button
                className="custom-btn btn room-desc-btn d-flex justify-content-center align-items-center rounded-pill"
                onClick={doingBooking}
              >
                Book Now
              </button>
            </div>
          </div>
        </div>
        {/* Room Description, Price and Book Now Button End */}

        {/* Footer Start */}
        <Footer />
        {/* Footer End */}
      </>
    );
}
